import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "NewPosts",
    component: () => import("../views/NewPosts.vue"),
  },
  {
    path: "/posts/:code/",
    name: "Post",
    pathToRegexpOptions: { strict: true },
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/Post.vue"),
  },
  {
    path: "/smi",
    name: "PressCenter",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PressCenter.vue"),
  },
  {
    path: "/coral-club",
    name: "Coral Club",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PressCoralClub.vue"),
  },
  {
    path: "/video",
    name: "Video",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PressVideo.vue"),
  },
  {
    path: "/russian-sign-language",
    name: "Russian sign language",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PressRussian.vue"),
  },
  {
    path: "/updates",
    name: "Updates",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Updates.vue"),
  },
  {
    path: "/events",
    name: "Events",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Events.vue"),
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes,
});

export default router;
